let widgetsPath = ''
if (localStorage.getItem('leadhit_widgets_path') !== null) {
  widgetsPath = localStorage.getItem('leadhit_widgets_path')
  console.log("Leadhit: Custom widgets path found")
  console.log("Leadhit: widgets path: " + widgetsPath)
}

let preview = window.top.lh_widgets_conf_demo ? true : false
let baseUrl

if(ENV === 'production') {
  baseUrl = 'https://service.leadhit.ru/widgets/static/'
}
else if(ENV === 'development') {
  baseUrl = 'http://service.localhost/widgets/static/'
}

let сonfig = {
  baseUrl: baseUrl,
  site_id: window.lh_clid,
  preview: preview,
  widgets_path:widgetsPath
}

export default сonfig